import { PhysicalAttackSkill, SpecialAttackSkill, StatusSkill } from "../../core/skill";
import { Effect, RoundEffect, ConsumeEffect } from "../../core/effect";
import { Timing } from "../../core/timing";
import { Ability } from "../../core/ablvl";

import * as type from "../../core/type";
import * as state from "../../core/state";
import * as effect from "../../core/effect";
import * as cond from "../../core/cond";
import * as pred from "../../core/pred";

export const 夜·魔灵之球 = new PhysicalAttackSkill(
    "夜·魔灵之球",
    type.暗影,
    [
        "吸取对手的能力提升，吸取成功则下1回合必定先出手",
        "自身体力低于最大体力的1/3时，威力为3倍",
    ],
    80,
    [
        new Effect(
            new effect.吞噬强化(),
            Timing.onDamage,
            undefined,
            [
                new RoundEffect(
                    Timing.triggered,
                    1,
                    new effect.先制(6),
                    Timing.battleStageBegin,
                ).nextRound(),
            ]
        ),
        new Effect(
            new effect.威力提升(200),
            Timing.beforeDamage,
            cond.若自身体力低于x分之一(3),
        )
    ],
    3,
    false,
)

export const 夜·幽幻之盾 = new StatusSkill(
    "夜·幽幻之盾",
    [
        "免疫下1次受到的攻击"
    ],
    [
        new ConsumeEffect(
            Timing.onSkillHit,
            1,
            new effect.免疫攻击(),
            Timing.beforeSkillHit
        )
    ],
);

export const 夜·斗志复燃 = new StatusSkill(
    "夜·斗志复燃",
    [
        "全属性+1，自身体力低于最大体力的1/2时效果翻倍",
        "4回合内，每回合吸取对手最大体力的1/3，体力低于最大体力的1/2时吸取效果翻倍",
        "下2回合，直接攻击必定打出致命一击",
        "下2回合，自身所有技能先制+2",
    ],
    [
        new Effect(
            new effect.强化(undefined, cond.若自身体力低于x分之一(2)),
            Timing.onSkillHit
        ),
        new RoundEffect(
            Timing.onSkillHit,
            4,
            new effect.吸取体力(pred.对手最大体力的x分之一(3), undefined, undefined, cond.若自身体力低于x分之一(2)),
            Timing.actionEnd,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.暴击(),
            Timing.beforeDamage,
        ).nextRound(),
        new RoundEffect(
            Timing.onSkillHit,
            2,
            new effect.先制(2),
            Timing.battleStageBegin,
        ).nextRound(),
    ],
);

export const 夜·双重暗影 = new PhysicalAttackSkill(
    "夜·双重暗影",
    type.暗影,
    [
        "3回合内，造成的攻击伤害不低于300",
        "3回合内，每回合附加300点固定伤害",
    ],
    150,
    [
        new RoundEffect(
            Timing.onSkillHit,
            3,
            new effect.保伤(300),
            Timing.beforeDamage,
        ),
        new RoundEffect(
            Timing.onSkillHit,
            3,
            new effect.固伤(300),
            Timing.onDamage,
        )
    ]
);

export const 夜神·魔君舞 = new PhysicalAttackSkill(
    "夜神·魔君舞",
    type.暗影,
    [
        "消除对手的回合类效果，消除成功则免疫下1回合受到的攻击",
        "若造成的伤害不低于300，则100%令对手害怕",
        "若造成的伤害不高于300，则吸取对手最大体力的1/3"
    ],
    160,
    [],
    0,
    true
);
